import { IBallot, IQuestion } from "./ballot-api";
import { ICandidate, ICandidateProfile } from "./candidate";

export enum ELECTION_STATUS {
    ACTIVE = "ACTIVE",
    COMPLETE = "COMPLETE",
}

export enum VOTING_ROUND_STATUS {
    DRAFT = "DRAFT",
    NOMINATIONS = "NOMINATIONS",
    VOTING = "VOTING",
    CLOSED = "CLOSED",
}

export enum ELECTION_MODE {
    SCHEDULE = "SCHEDULE",
    MANUAL = "MANUAL",
}

export enum VOTING_ROUND_MODE {
    PREVIEW = "PREVIEW",
    LIVE = "LIVE",
}

export interface IStyleConfig {
    layout_color?: string;
    interface_color?: string;
    success_color?: string;
    error_color?: string;
    electify_logo?: 'white' | 'black' | 'blue';
}


// the information available to the consumer about the election/voting_round
export interface IElectionRound {
    label: string;
    status: VOTING_ROUND_STATUS;
    mode: VOTING_ROUND_MODE;
    election_id: string,
    election_label: string,
    election_status: ELECTION_STATUS,
    nominations_schedule?: RoundSchedule,
    voting_schedule?: RoundSchedule,
    organisation_id: string,
    short_description: string | null | undefined,
    display_order?: number;
    style_config?: IStyleConfig;
    logo_lg_url?: string;
    logo_sm_url?: string;
    ballots: ApiBallot[];
    voting_payload_cache_id?: string | null;
}

export interface ApiBallot extends IBallot {
    questions: ApiIQuestion[];
}

export interface ApiIQuestion extends IQuestion {
    candidates: ICandidate[];
}

export interface IProxyVote {
    voter_id: string;
    label: string;
    submitted: boolean;
    self: boolean;
}

export interface ISubmitState {
    self_submitted: boolean;
    proxy_submitted: boolean | null;
    proxy_votes?: IProxyVote[] | null;
}
export interface ISubmitStateMap {
    [ballot_id: string]: ISubmitState;
}



export interface RoundSchedule {
    open_at: Date;
    close_at: Date;
    open_at_text: string;
    close_at_text: string;
    auto: boolean;
    enabled: boolean;
}


export interface IElectionStep {
    id: string;
    label: string;
    url: string;
    completed: boolean | null;
    icon?: JSX.Element;
}